<template lang="pug">
  q-page.geometry.q-pa-sm
    .row.gutter-md
      .col-12
        geometry-editor(:d="d", :r="r", :z="z", :d_eff="d_eff", :d_flat="d_flat", :ap="ap", :ae="ae", :vc="vc", :vf="vf", :fz="fz")
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-6
                q-field(label-width="2", helper="tool diameter")
                  q-input(v-model="d", type="number" suffix="mm")
                  div(slot="label", v-katex="'D'")
                q-field(label-width="2", helper="tool radius")
                  q-input(v-model="r", type="number" suffix="mm")
                  div(slot="label", v-katex="'R'")
                q-field(label-width="2", helper="flute count")
                  q-input(v-model="z", type="number" suffix="")
                  div(slot="label", v-katex="'Z'")
                q-field(label-width="2", helper="axial doc")
                  q-input(v-model="ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_p'")
              .col-6
                q-field(label-width="2", helper="effective diameter")
                  q-input(v-model="d_eff", type="number" suffix="mm")
                  div(slot="label", v-katex="'D_{\\\\text{eff}}'")
                q-field(label-width="2", helper="flat diameter")
                  q-input(v-model="d_flat", type="number" suffix="mm")
                  div(slot="label", v-katex="'D_{\\\\text{flat}}'")
    .row
      .col-12
        q-card
          q-card-main
            cutter(:d="d",:r="r",:z="z",:ap="ap",:ae="ae")
</template>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';
import CuttingDataMixin from '@/mixins/cutting-data.js';
import GeometryEditor from '@/components/GeometryEditor.vue';
import Cutter from '@/components/Cutter.vue';

export default {
  name: 'geometry',
  components: {
    Cutter,
    GeometryEditor
  },
  mixins: [CuttingDataMixin],
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
